<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useEvaluationFileIndexStore} from "@/stores/Evaluation/EvaluationFileIndex";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        readonly: Boolean,
        multiple: Boolean,
        notClearable: Boolean,
        maxSelect: Boolean,
        label: String,
        rules: Array,
        type: String,
    },
    emits: ["input", "change"],
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const evaluationFileIndexStore = useEvaluationFileIndexStore();

        const index = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/evaluationFileIndices`).then(response => {
                evaluationFileIndexStore.setEvaluationFileIndices(response.data);
                if(response.data.length > 0 && props.maxSelect) {
                    input(response.data[response.data.length - 1].id);
                }
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        function change() {
            emit('change')
        }

        watch(() => props.value, () => {
            index.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            evaluationFileIndexStore,
            loading,
            inputColor,
            backgroundColor,
            index,
            input,
            change,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
            v-model="index"
            :items="evaluationFileIndexStore.evaluationFileIndices"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :multiple="multiple"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly && !notClearable"
            @input="input"
            @change="change"
            :rules="rules"
            hide-details="auto"
        />

        <input type="hidden">
    </div>
</template>

<style scoped>

</style>